import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map } from 'immutable';
import styled from '@emotion/styled';

import Loading from '../../../Loading';

import { MatchedAccount } from './components/MatchedAccount';
import { IdMissionVerifications } from './components/IdMissionVerifications/IdMissionVerifications';
import MatchedPaymentMethods from './components/MatchedPaymentMethods.jsx';
import { PaymentDeclines } from './components/PaymentDeclines';
import ReviewAccount from './components/ReviewAccount.jsx';
import { ManualAV } from './components/ManualAV';
import { DOBMismatch } from './components/DOBMismatch';
import ReviewDepositRestrictions from './components/ReviewDepositRestrictions.jsx';


export const SectionHeader = styled('h2')`
    font-size: 16px !important;
    margin: 0 0 12px !important;
`;

class FraudAndCompliances extends React.Component {
    static propTypes = {
        type: PropTypes.string,
        status: PropTypes.string,
        header: PropTypes.string,
        customers: ImmutablePropTypes.map,
        className: PropTypes.string,

        onCancelRequest: PropTypes.func.isRequired,
        onAssignRequest: PropTypes.func.isRequired,
        onUnassignRequest: PropTypes.func.isRequired,
        onOpenAccountRequest: PropTypes.func.isRequired
    };

    static defaultProps = {
        header: '',
        customers: Map(),
        className: ''
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            components: []
        };
    }

    render() {
        const { header, data, className, status, type, entityKey, dataTest } = this.props;
        let message;

        if (status === 'ERROR') {
            message = <div className='message message__error'>Error during fetching data</div>;
        } else if (status === 'FINISHED' && !data && !data.size) {
            message = <div className='message'>There are no items</div>;
        }
        const entityElement = entityKey.map(el => {
            switch (el) {
                case 'matched-account':
                    return <MatchedAccount key='matched-account' {...this.props} />;
                case 'payment-declines':
                    return <PaymentDeclines key='payment-declines' {...this.props} />;
                case 'new-matched-payment-methods':
                    return <MatchedPaymentMethods key='new-matched-payment-methods' {...this.props} />;
                case 'review-account':
                    return <ReviewAccount key='review-account' {...this.props} />;
                case 'call-credit-age-verification':
                    return <DOBMismatch key='call-credit-age-verification' {...this.props} />;
                case 'call-credit-validation-errors':
                    return <ManualAV key='call-credit-validation-errors' {...this.props} />;
                case 'alert-all-deposits':
                    return <PaymentDeclines key='alert-all-deposits' {...this.props} />;
                case 'alert-all-withdrawals':
                    return <PaymentDeclines key='alert-all-withdrawals' {...this.props} />;
                case 'deposit-restrictions':
                    return <ReviewDepositRestrictions key='deposit-restrictions' {...this.props} />;
                case 'id-mission-verifications':
                    return <IdMissionVerifications key='id-mission-verifications' {...this.props} />;
                default:
                    return <Loading message='Loading...' active={status === 'IN_PROGRESS'} />;
            }
        });

        return (
            <div className={className} data-test={dataTest}>
                <SectionHeader data-test='section-header'>{header}</SectionHeader>
                {message}
                {entityElement}
                <Loading message='Loading...' active={status === 'IN_PROGRESS'} />
            </div>
        );
    }
}

export default FraudAndCompliances;
